import { CreditCard, ShieldCheck, Zap } from "lucide-react";
import Logo from "./Logo";
import { useCart } from "@/context/CartContext";

export default function Footer() {
  const { paymentsMode } = useCart();
  const live = paymentsMode === "live";
  return (
    <footer data-testid="footer" className="border-t border-voltaic-line bg-voltaic-surface/40">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-10">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
          <div className="max-w-xs">
            <Logo />
            <p className="mt-4 text-sm leading-relaxed text-voltaic-muted">
              Premium next-gen electronics, engineered to electrify. Drop 07 out now.
            </p>
          </div>
          <div className="flex gap-16 font-mono text-[11px] uppercase tracking-[0.2em] text-voltaic-muted">
            <div className="space-y-3">
              <p className="text-voltaic-ink">Store</p>
              <a href="/" className="block transition-colors hover:text-voltaic-cyan">Home</a>
              <a href="/shop" className="block transition-colors hover:text-voltaic-cyan">Catalogue</a>
              <a href="/guides" className="block transition-colors hover:text-voltaic-cyan">Buying guides</a>
              <a href="/checkout" className="block transition-colors hover:text-voltaic-cyan">Checkout</a>
            </div>
            <div className="space-y-3">
              <p className="text-voltaic-ink">Support</p>
              <span className="block">Free ship $999+</span>
              <span className="block">Promo: VOLTAIC20</span>
              <span className="block">{live ? "Live payments" : "Stripe test mode"}</span>
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-voltaic-line pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-voltaic-muted sm:flex-row sm:items-center">
          <p>© 2026 VOLTAIC — Built to electrify</p>
          <div className="flex items-center gap-5">
            <span className="flex items-center gap-1.5"><CreditCard size={13} className="text-voltaic-cyan" /> Stripe secured</span>
            <span className="flex items-center gap-1.5"><ShieldCheck size={13} className="text-voltaic-cyan" /> {live ? "Live payments" : "Test mode"}</span>
            {!live && <span className="flex items-center gap-1.5"><Zap size={13} className="text-voltaic-cyan" /> 4242 ready</span>}
          </div>
        </div>
      </div>
    </footer>
  );
}
